export default link => {
  if (!link) return false;
  return link.includes('youtube');
};
